import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Counter from "../Counter";
export var TopRightCounter = styled(Counter).withConfig({
  displayName: "TabBarNotification__TopRightCounter",
  componentId: "sc-1voetr6-0"
})(["transform:translate(14px,-7px);position:absolute;"]);
var Wrapper = styled.div.withConfig({
  displayName: "TabBarNotification__Wrapper",
  componentId: "sc-1voetr6-1"
})(["position:relative;"]);
export var TabBarNotification = function TabBarNotification(_ref) {
  var notificationNumber = _ref.notificationNumber,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TopRightCounter, {
    notificationNumber: notificationNumber
  }), children);
};
TabBarNotification.propTypes = process.env.NODE_ENV !== "production" ? {
  notificationNumber: PropTypes.number,
  children: PropTypes.node.isRequired
} : {};
export default TabBarNotification;
//# sourceMappingURL=TabBarNotification.js.map